import Communication from './communication';
import Trade from './trade';
import Agency from './agency';

export {
  Communication,
  Trade,
  Agency
}



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/index.js